
import './landing.css'
import React, { useState } from 'react';
import WhySignUpBox from './landingComponent/WhySignUpBox';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import { CarouselData } from './datas'
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import icon2 from '../../assets/images/icon-2.png'
import icon3 from '../../assets/images/icon-3.png'
import icon4 from '../../assets/images/icon-4.png'
import Countdown from './landingComponent/Countdown';
import { Navigate, useNavigate } from 'react-router-dom';

const initialState = {
    name: '',
    email: '',
    phoneNumber: '',
    message: '',
    userType: ''
}



const Landing = () => {

    const navigate = useNavigate();

    const [cState, updateCState] = useState(initialState);
    const [isLoading, setIsLoading] = useState(false); // Loading state for API call


    const { name, email, phoneNumber, message, userType } = cState;

    const handleInputChange = (e) => {
        const { name, value } = e.target
        updateCState({
            ...cState, [name]: value
        })
    }

    console.log("cState", cState);

    // const handleSubmit = () => {
    //     alert("Hello");
    // }


    const handleSubmit = async (e) => {
        console.log("hiiiiiiiiiiiii")
        e.preventDefault(); // Prevent default form submission

        // Form validation
        if (!name || !email || !userType ||!phoneNumber) {
            alert('Please fill in all required fields!');
            return;
        }
        

        const payload = {
            name,
            email,
            phoneNumber,
            message,
            userType,
        };

        console.log("payload", payload)

        try {
            setIsLoading(true); // Start loading
        //    for local Ip 
            // const response = await fetch('http://15.206.16.230:4100/api/v1/static/sendEmail', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(payload),
            // });

            // for live website 
            const response = await fetch('https://pgdekho.com:4500/api/v1/user/sendEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            console.log(data)

            if (response.ok) {
                alert('You have successfully signed up for early access');
                updateCState(initialState); // Reset form
                let URL = 'https://www.instagram.com/iline.ai/'
                window.location.href = URL
                
            } else {
                console.error('Error:', data);
                alert('There was an error submitting the form. Please try again.');
            }
        } catch (error) {
            console.error('API Error:', error);
            alert('Failed to connect to the server. Please check your network.');
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    const data = [
        {
            heading: 'Early access to the app',
            imgSrc: icon2
        },
        {
            heading: 'Special rewards for early adopters',
            imgSrc: icon3
        },
        {
            heading: 'Be part of shaping the product with feedback opportunities.',
            imgSrc: icon4
        }
    ]

    return (
        <>
            <div className='LandingHeader' id='LandingHeader'>
                <a href="javascript:void(0)"><img src={require('../../assets/images/logo.png')} /></a>
                <h6>Call Us Today <span>+91-9220536259</span></h6>
            </div>
            <section className='HeroSection'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <div className="LeftBox">
                                <h2>Be the <span>First</span> to <br /> Experience the Future <br /> of <span>Smart Mobility</span> </h2>
                                <p>Join our exclusive list to get early access, special <br /> features, and a sneak peek into a smarter tomorrow.</p>
                                <button>Sign Up Now for Early Access</button>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <div className="RightBox">
                                <div className="EarlyAccess">
                                    <h3>Get Early Access</h3>
                                    <form>
                                        <ul>
                                            <li>
                                                <label className='Radio'> Customer
                                                    <input type="radio" name="userType" value="Customer" checked={userType === "Customer"} onChange={handleInputChange} />
                                                    <span className='checkmark'></span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className='Radio'> Fleet Owner
                                                    <input type="radio" name="userType" value="Fleet Owner" checked={userType === "Fleet Owner"} onChange={handleInputChange} />
                                                    <span className='checkmark'></span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className='Radio'> Driver
                                                    <input type="radio" name="userType" value="Driver" checked={userType === "Driver"} onChange={handleInputChange} />
                                                    <span className='checkmark'></span>
                                                </label>
                                            </li>
                                        </ul>
                                        <div className="form-group">
                                            <input type="text" className='form-control' placeholder='Your name' name='name' value={name} onChange={handleInputChange} autoComplete />
                                        </div>
                                        <div className="form-group">
                                            <input type="email" className='form-control' placeholder='Your email' name='email' value={email} onChange={handleInputChange} autoComplete />
                                        </div>
                                        <div className="form-group">
                                            <input type="number" className='form-control' placeholder='Mobile Number' name='phoneNumber' value={phoneNumber} onChange={handleInputChange} autoComplete />
                                        </div>
                                        <div className="form-group">
                                            <textarea rows={6} placeholder='Message' className='form-control' name='message' value={message} onChange={handleInputChange} autoComplete ></textarea>
                                        </div>
                                        <button type='submit' onClick={handleSubmit}>Sign Up Now for Early Access</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="WhySignUpArea">
                <div className="container">
                    <div className="Outer">
                        <div className='Left'>
                            <h1>Why Sign Up?</h1>
                            <p>With lots of unique blocks, you can easily build a page easily without any coding. </p>
                        </div>
                        <ul className="Right">
                            {
                                data?.map((item) => {
                                    return (<li><WhySignUpBox imgSrc={item?.imgSrc} heading={item?.heading} /></li>)
                                })
                            }
                        </ul>
                    </div>
                </div>
            </section>
            <section className='OurPartners'>
                <div className="container">
                    <div className="section-title">
                        <h2>Our Partners</h2>
                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do <br /> eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
                    </div>
                    <ul>
                        <li><img src={require('../../assets/images/landing-images/partner-1.png')} /></li>
                        <li><img src={require('../../assets/images/landing-images/partner-2.png')} /></li>
                        <li><img src={require('../../assets/images/landing-images/partner-3.png')} /></li>
                    </ul>
                </div>
            </section>
            <section className='HurrySignUp'>
                <div className="container">
                    <div className="Outer">
                        <div className="Left">
                            <h2>Hurry! Early sign-ups close in</h2>
                            <Countdown targetDate={new Date('January 31, 2025 00:00:00')} />

                            <a href='#LandingHeader'>Sign Up Now for Early Access</a>
                        </div>
                        <div className="Right">
                            <img src={require('../../assets/images/landing-images/product-img.png')} />
                        </div>
                    </div>
                </div>
            </section>
            <footer className='mt-0'>
                <div className='FooterLand'>
                    <div className="container">
                        <div className="Content">
                            <a href="javascript:void(0);" className='Logo'><img src={require('../../assets/images/logo.png')} /></a>
                            <p>Iline  is a forward-thinking startup dedicated to transforming the logistics industry by leveraging electric vehicles (EVs) to minimize carbon footprints and enhance air quality. Through advanced, AI-driven technology, Iline streamlines scheduling and optimizes battery management to maximize vehicle efficiency and sustainability. By integrating intelligent systems, the company ensures seamless operations, reduces energy consumption, and passes on cost savings directly to its users. Iline Solutions is at the forefront of eco-friendly logistics, committed to creating cleaner, smarter, and more cost-effective delivery solutions that benefit businesses, communities, and the environment.</p>
                            {/* <ul>
                                <li><a href="javascript:void(0);">About Us</a></li>
                                <li><a href="javascript:void(0);">Privacy Policy</a></li>
                                <li><a href="javascript:void(0);">Contact Information</a></li>
                            </ul> */}
                            <div className="Bottom">
                                <p>&copy; Copyright, All Right Reserved</p>
                                <ul>
                                    <li><a href="https://x.com/i/flow/login?redirect_after_login=%2FIlineIndia"><FaXTwitter /></a></li>
                                    <li><a href="https://www.facebook.com/IlineIndia"><FaFacebookSquare /></a></li>
                                    <li><a href="https://www.instagram.com/iline.ai/"><FaInstagram /></a></li>
                                    <li><a href="https://www.linkedin.com/company/ilineindia/"><FaLinkedin /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>

    )
}

export default Landing;